export default (html, css, javascript, stylesheets, scripts) => {
  return `<html>
      <head>
        ${stylesheets.map(s => `<link rel="stylesheet" href=${s} crossorigin="anonymous"></link>`)}
        ${scripts.map(s => `<script crossorigin src=${s}><\/script>`)}
        <style>${css}</style>    
      </head>
      <body>
        <div>
          ${html}
        </div>
        <script>${javascript}<\/script>
      </body>
    </html>
  `;
}